/**
 * 本番
 */
const GOOGLE_API_KEY = 'AIzaSyCUVFBVSQzXDYgLq0jCCWP4xXAl02vSNf4';
const FETCH_SHOPLIST_URL = 'https://xmobile.ne.jp/wp-json/acf/v3/shop_detail?per_page=500';
const FETCH_SHOPLIST_OPT = {}

const DEFAULT_ORIGIN = {
  lat: 35.6574005, 
  lng: 139.7013738,  
}
const DEFAULT_KEYWORDS = '150-0002 東京都渋谷区渋谷3−18−5 佐藤エステートビル 本館１F';


const ERROR_TYPE = {
  GMAP: 'GMAP', 
  SHOP: 'SHOP',  
  GEO: 'GEO',
  ADDRESS: 'ADDRESS',
  SEARCH: 'SEARCH',
}


export default {
  GOOGLE_API_KEY,
  FETCH_SHOPLIST_URL,
  FETCH_SHOPLIST_OPT,
  DEFAULT_ORIGIN, 
  DEFAULT_KEYWORDS,
  ERROR_TYPE,
}